import { render, staticRenderFns } from "./CollapsibleFilterPanelGroup.vue?vue&type=template&id=5a644f65&scoped=true&"
import script from "./CollapsibleFilterPanelGroup.vue?vue&type=script&lang=js&"
export * from "./CollapsibleFilterPanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleFilterPanelGroup.vue?vue&type=style&index=0&id=5a644f65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a644f65",
  null
  
)

export default component.exports